import type { PropsWithChildren, ReactNode } from 'react';
import { useState } from 'react';

import BpkBottomSheet from '@skyscanner-internal/backpack-web/bpk-component-bottom-sheet';
import BpkSelectableChip from '@skyscanner-internal/backpack-web/bpk-component-chip';

export type BottomSheetChipProps = PropsWithChildren<{
  id: string;
  label: string;
  title: string;
  icon?: ReactNode;
  closeOnScrimClick?: boolean;
  closeOnEscPressed?: boolean;
  trackingCommonParams?: string;
  trackingElementId?: string;
}>;

const BottomSheetChip = ({
  children = undefined,
  closeOnEscPressed = true,
  closeOnScrimClick = true,
  icon = undefined,
  id,
  label,
  title,
  trackingCommonParams = undefined,
  trackingElementId = undefined,
}: BottomSheetChipProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <BpkSelectableChip
        leadingAccessoryView={icon}
        accessibilityLabel={label}
        onClick={() => setIsOpen(true)}
        data-tracking-element-id={trackingElementId}
        data-tracking-common-params={trackingCommonParams}
      >
        {label}
      </BpkSelectableChip>

      <BpkBottomSheet
        id={id}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={title}
        ariaLabel={title}
        closeOnScrimClick={closeOnScrimClick}
        closeOnEscPressed={closeOnEscPressed}
      >
        {children}
      </BpkBottomSheet>
    </div>
  );
};

export default BottomSheetChip;
